import React, { } from 'react';
import { Page, Navbar, NavRight, Link, Block, Searchbar} from "framework7-react";

const PageSearchMenu = () => {
  return (
    <Page className='bg-white'>
      <Navbar title="Searchbar" noShadow backLink="Back">
        <NavRight>
          <Link searchbarEnable=".searchbar-demo" iconIos="f7:search" iconMd="material:search" />
        </NavRight>
        <Searchbar
          className="searchbar-demo"
          expandable
          searchContainer=".search-list"
          searchIn=".item-title"
        />
      </Navbar>
      <div className="otp-container mt-5">
      <Block>        
      </Block>
      </div>
    </Page>
  );
};

export default PageSearchMenu;